(() => {
  const init = async root => {
    if (!root || root.dataset.bound) return;
    root.dataset.bound = 'true';
    const params = new URLSearchParams(window.location.search);
    const size = Number(params.get('rocky_size'));
    const age = {1: [18,25], 2: [26,30], 3: [31,40]}[params.get('rocky_age')];
    const light = params.get('rocky_light') === '1';
    const stock = params.get('rocky_stock') === '1';
    const title = root.querySelector('[data-rk-match-title]');
    const copy = root.querySelector('[data-rk-match-copy]');
    const status = root.querySelector('[data-rk-match-status]');
    const grid = root.querySelector('[data-rk-match-grid]');
    const retry = root.querySelector('[data-rk-match-retry]');
    if (size >= 18 && size <= 40) {
      title.textContent = root.dataset.sizeTitle.replace('%size%', size);
      copy.textContent = root.dataset.sizeCopy;
    } else if (age) {
      title.textContent = root.dataset[{1:'ageOne',2:'ageTwo',3:'ageThree'}[params.get('rocky_age')]];
      copy.textContent = root.dataset.ageCopy;
    } else if (light) {
      title.textContent = root.dataset.lightTitle;
      copy.textContent = root.dataset.lightCopy;
    }
    const numbers = value => String(value || '').split('|').flatMap(part => part.trim().split(/\D+/)).filter(Boolean).map(Number);
    const apply = () => {
      let count = 0;
      grid.querySelectorAll('[data-rk-match-product]').forEach(card => {
        const sizes = numbers(stock ? card.dataset.availableSizes : card.dataset.sizes);
        const matches = (!size || sizes.includes(size)) && (!age || sizes.some(n => n >= age[0] && n <= age[1])) && (!light || card.dataset.light === 'true');
        card.hidden = !matches;
        if (matches) count++;
      });
      grid.hidden = false;
      grid.removeAttribute('aria-busy');
      status.textContent = count ? root.dataset.count.replace('%count%', count) : root.dataset.empty;
    };
    const load = async () => {
      retry.hidden = true;
      try {
        let next = root.querySelector('[data-rk-match-next]');
        const visited = new Set();
        while (next) {
          const url = new URL(next.href, location.origin);
          url.searchParams.set('view', 'rocky-match');
          if (visited.has(url.href)) throw new Error('catalog-pagination');
          visited.add(url.href);
          const response = await fetch(url.href);
          if (!response.ok) throw new Error('catalog-load');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const pageGrid = page.querySelector('[data-rk-match-grid]');
          if (!pageGrid) throw new Error('catalog-markup');
          const fragment = document.createDocumentFragment();
          pageGrid.querySelectorAll('[data-rk-match-product]').forEach(card => fragment.append(card));
          grid.append(fragment);
          next.remove();
          next = page.querySelector('[data-rk-match-next]');
          if (next) root.append(next);
          document.dispatchEvent(new CustomEvent('rocky:products-loaded', {detail:{root:grid}}));
        }
        apply();
      } catch {
        status.textContent = root.dataset.error;
        retry.hidden = false;
      }
    };
    retry.addEventListener('click', load);
    await load();
  };
  const start = () => document.querySelectorAll('[data-rk-match-catalog]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  document.addEventListener('shopify:section:load', start);
})();
